import axios from 'axios';

export const contact = async (formData) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/contact/`;
  try {
    const response = await axios.post(apiUrl, formData);
    return response.data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
};
